(() => {
  const openLinkedRecord = () => {
    const id = window.location.hash.slice(1);
    if (!/^(clinical|patent)-\d{2}$/.test(id)) return;
    const record = document.getElementById(id);
    if (record instanceof HTMLDetailsElement) {
      record.open = true;
      requestAnimationFrame(() => record.scrollIntoView({ block: 'start' }));
    }
  };
  openLinkedRecord();
  window.addEventListener('hashchange', openLinkedRecord);
})();
